import gql from 'graphql-tag';

const ADD_ALERT_VIEW = gql`
  mutation($input: ListViewInput!) {
    addAlertView(input: $input) {
      id
      name
      viewCondition
      customView
      shared
      systemViewProperty
    }
  }
`;

const UPDATE_ALERT_VIEW = gql`
  mutation($viewID: ID!, $input: ListViewInput!) {
    updateAlertView(viewID: $viewID, input: $input) {
      id
      name
      viewCondition
      customView
      shared
      systemViewProperty
    }
  }
`;

const GET_ALERT_VIEW_LIST = gql`
  query {
    getAlertViews {
      id
      name
      viewCondition
      customView
      shared
      systemViewProperty
    }
  }
`;

const GET_ALERT_LIST = gql`
  query($listInfo: ListInfoInput!) {
    getAlertList(listInfo: $listInfo) {
      alerts {
        message
        createdTime
        id
        status
        severity
        description
        externalSource
        resolvedTime
        occurrenceCount
        asset {
          name
          assetId
          assetClass {
            classId
          }
          client {
            name
            accountId
          }
          site {
            name
            id
          }
        }
        policy {
          name
          policyType
        }
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
        condition
      }
    }
  }
`;

const GET_ALERT_LISTVIEW_META = gql`
  query {
    getAlertViewMetaInfoV2
  }
`;

const GET_POLICIES_BY_CRITERIA = gql`
  query($listInfo: ListInfoInput!) {
    getPolicyListByCriteria(listInfo: $listInfo) {
      policyId
      name
    }
  }
`;

const GET_POLICY_TYPES = gql`
  query {
    getPolicyTypes
  }
`;

const GET_ALERT_VIEW = gql`
  query($viewID: ID!) {
    getAlertView(viewID: $viewID) {
      id
      name
      viewCondition
      customView
      shared
      systemViewProperty
    }
  }
`;

const DELETE_ALERT_VIEW = gql`
  mutation($viewID: ID!) {
    deleteAlertView(viewID: $viewID)
  }
`;

const GET_ALERT_META_INFO = gql`
  query {
    getAlertViewMetaInfoV3
  }
`;

const GET_ALERT_META_INFO_V4 = gql`
  query {
    getAlertViewMetaInfoV4
  }
`;

const GET_ALERT_DETAILS_META_INFO = gql`
  query {
    getAlertsForAssetMetaInfo
  }
`;

const GET_ALERT_DETAILS_META_INFO_V2 = gql`
  query {
    getAlertsForAssetMetaInfoV2
  }
`;

const MOVE_ALERT_TO_TICKET = gql`
  mutation($alertId: ID!) {
    convertAlertToTicket(alertId: $alertId)
  }
`;

const RESOLVE_ALERT = gql`
  mutation($alertId: ID!) {
    resolveAlert(alertId: $alertId)
  }
`;
const RESOLVE_ALERTS = gql`
  mutation($alertIds: [ID!]) {
    resolveAlerts(alertIds: $alertIds)
  }
`;

const RESOLVE_ALERTS_V2 = gql`
  mutation($input: SelectionInput) {
    resolveAlertsV2(input: $input)
  }
`;

const DELETE_ALERTS = gql`
  mutation($alertIds: [ID!]) {
    deleteAlerts(alertIds: $alertIds)
  }
`;

const DELETE_ALERTS_V2 = gql`
  mutation($input: SelectionInput) {
    deleteAlertsV2(input: $input)
  }
`;

const GET_UNIQUE_POLICY_NAMES = gql`
  query($pattern: String) {
    getUniquePolicyNames(pattern: $pattern)
  }
`;

const GET_ALERT_OCCURRENCES = gql`
  query GetAlertOccurrences($alertId: ID!, $listInfo: ListInfoInput!) {
    getAlertOccurrences(alertId: $alertId, listInfo: $listInfo) {
      alertOccurrences {
        occurrenceId
        occurrenceTime
        description
      }
      listInfo {
        page
        pageSize
        totalCount
        sort {
          attribute
          order
        }
      }
    }
  }
`;

export {
  ADD_ALERT_VIEW,
  UPDATE_ALERT_VIEW,
  GET_ALERT_VIEW_LIST,
  GET_ALERT_LIST,
  GET_ALERT_LISTVIEW_META,
  GET_POLICIES_BY_CRITERIA,
  GET_POLICY_TYPES,
  GET_ALERT_VIEW,
  DELETE_ALERT_VIEW,
  GET_ALERT_META_INFO,
  MOVE_ALERT_TO_TICKET,
  RESOLVE_ALERT,
  GET_ALERT_DETAILS_META_INFO,
  GET_ALERT_META_INFO_V4,
  GET_ALERT_DETAILS_META_INFO_V2,
  RESOLVE_ALERTS,
  GET_UNIQUE_POLICY_NAMES,
  DELETE_ALERTS,
  DELETE_ALERTS_V2,
  RESOLVE_ALERTS_V2,
  GET_ALERT_OCCURRENCES
};
